import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol && _getIteratorMethod(r) || r["@@iterator"]; if (!t) { if (_Array$isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context6; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty(_context6 = {}.toString.call(r)).call(_context6, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import moment from "moment";
/**
 * Filters an array in place. JS's default array filter function returns a new array. Use this if you want tomodify an existing array
 *
 * @param arr - array to filter in place
 * @param filterFunc - custom conditions for filtering
 * @returns numOfItemsRemoved: number - num of elements that did not meet filter conidtions
 */
export function filterInPlace(arr, filterFunc) {
  var numOfItemsRemoved = 0;
  var i = 0; // Keeps track of index as we iterate through arr
  var j = 0; // Keeps track of index of last item we want to keep in array

  while (i < arr.length) {
    var value = arr[i];

    // If conditions in custom filter function are met, keep in array, and increments j
    // otherwise incremenet numOfItems removed counter
    if (filterFunc(arr[i])) {
      arr[j++] = value;
    } else {
      numOfItemsRemoved++;
    }
    i++;
  }
  arr.length = j;
  return numOfItemsRemoved;
}
export function isNullOrUndefined(value) {
  return value === null || value === undefined;
}
export function sortByValue(valueA, valueB, reverseSort) {
  var isEmptyA = valueA === null || valueA === undefined || valueA === "";
  var isEmptyB = valueB === null || valueB === undefined || valueB === "";
  if (isEmptyA && isEmptyB) {
    return 0;
  }
  if (isEmptyA) {
    return 1;
  }
  if (isEmptyB) {
    return -1;
  }
  if (typeof valueA === "string" && typeof valueB === "string") {
    var result = valueA.localeCompare(valueB, undefined, {
      sensitivity: "base"
    });
    return reverseSort ? -result : result;
  }
  if (valueA < valueB) {
    return reverseSort ? 1 : -1;
  }
  if (valueA > valueB) {
    return reverseSort ? -1 : 1;
  }
  return 0;
}
export var sortByDate = function sortByDate(a, b, reverseSort, dateFormat) {
  var isEmptyA = a === null || a === undefined || a === "";
  var isEmptyB = b === null || b === undefined || b === "";
  if (isEmptyA && isEmptyB) return 0;
  if (isEmptyA) return 1;
  if (isEmptyB) return -1;
  var dateA = moment(a, dateFormat);
  var dateB = moment(b, dateFormat);

  // Check for invalid dates (should also go to the bottom)
  var isInvalidA = !dateA.isValid();
  var isInvalidB = !dateB.isValid();
  if (isInvalidA && isInvalidB) return 0;
  if (isInvalidA) return 1;
  if (isInvalidB) return -1;
  if (dateA.isSame(dateB)) {
    return 0;
  }
  if (reverseSort) {
    return dateA.isBefore(dateB) ? 1 : -1;
  }
  return dateA.isBefore(dateB) ? -1 : 1;
};
export function sortByFloorSuite(a, b, reverseSort) {
  if (isNullOrUndefined(a)) {
    return 1;
  }
  if (isNullOrUndefined(b)) {
    return -1;
  }
  if (_includesInstanceProperty(a).call(a, "LL")) {
    return reverseSort ? 1 : -1;
  }
  if (_includesInstanceProperty(b).call(b, "LL")) {
    return reverseSort ? -1 : 1;
  }
  if (_includesInstanceProperty(a).call(a, "Ground")) {
    return reverseSort ? 1 : -1;
  }
  if (_includesInstanceProperty(b).call(b, "Ground")) {
    return reverseSort ? -1 : 1;
  }
  if (_includesInstanceProperty(a).call(a, "Mezzanine")) {
    return reverseSort ? 1 : -1;
  }
  if (_includesInstanceProperty(b).call(b, "Mezzanine")) {
    return reverseSort ? -1 : 1;
  }
  return reverseSort ? b.localeCompare(a, undefined, {
    numeric: true,
    sensitivity: "base"
  }) : a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: "base"
  });
}
export function getArrayOfIdsFromEdgesObject(objectWithEdges) {
  var _context, _objectWithEdges$edge;
  if (!objectWithEdges) return [];
  return _mapInstanceProperty(_context = (_objectWithEdges$edge = objectWithEdges === null || objectWithEdges === void 0 ? void 0 : objectWithEdges.edges) !== null && _objectWithEdges$edge !== void 0 ? _objectWithEdges$edge : []).call(_context, function (_ref) {
    var node = _ref.node;
    return node.id;
  });
}
export function getArrayOfNodesFromEdgesObject(objectWithEdges) {
  var _context2, _objectWithEdges$edge2;
  if (!objectWithEdges) return [];
  return _mapInstanceProperty(_context2 = (_objectWithEdges$edge2 = objectWithEdges === null || objectWithEdges === void 0 ? void 0 : objectWithEdges.edges) !== null && _objectWithEdges$edge2 !== void 0 ? _objectWithEdges$edge2 : []).call(_context2, function (_ref2) {
    var node = _ref2.node;
    return node;
  });
}
export function isStagingOrDev() {
  return window.IN_STAGING || window.IN_DEBUG_MODE;
}

// If 'plural' is provided, use it instead of appending "s", example: 'city' -> 'cities'
export function createSingleOrPluralText(text, value) {
  var plural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  if (value !== 1) {
    return plural ? plural : "".concat(text, "s");
  }
  return text;
}
export function convertToIntegerIfNoDecimalValue(value) {
  return value % 1 === 0 ? Math.floor(value) : value;
}
export function formatDate(date, format) {
  return moment(date).format(format);
}
export var validUrlFormat = /^((http|https):\/\/)?(www\.)?(?!.*(http|https|www\.))([a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+)\/?$/;
export var getClickableUrlLink = function getClickableUrlLink(link) {
  return _startsWithInstanceProperty(link).call(link, "http://") || _startsWithInstanceProperty(link).call(link, "https://") ? link : "http://".concat(link);
};
export function pickOptimizedImages(view, optimizedImages) {
  var _context3;
  if (!_Array$isArray(optimizedImages) || optimizedImages.length === 0) {
    return [];
  }
  return _mapInstanceProperty(_context3 = _filterInstanceProperty(optimizedImages).call(optimizedImages, function (image) {
    return !image.isPdf;
  })).call(_context3, function (image) {
    return pickOptimizedImageNode(view, image);
  });
}
export function pickOptimizedImageNode(view, node) {
  if (!node || !_Array$isArray(node.optimizedImages) || node.optimizedImages.length === 0) {
    var _node$url;
    return (_node$url = node === null || node === void 0 ? void 0 : node.url) !== null && _node$url !== void 0 ? _node$url : "";
  }
  var _iterator = _createForOfIteratorHelper(node.optimizedImages),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var optimized = _step.value;
      if (optimized.view === view.value) {
        return optimized.url;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return node.url;
}

// These header not set in stone but is used in multiple places
// If this becomes more widely used, write a test and document
export var getHeaderTypographyVariantWithResize = function getHeaderTypographyVariantWithResize(theme, windowWidth) {
  if (windowWidth < _valuesInstanceProperty(theme.breakpoints).smMd) {
    return "h3";
  } else if (windowWidth < _valuesInstanceProperty(theme.breakpoints).xl) {
    return "h2";
  }
  return "h1";
};
export var getTransactionMarketDisplayLabelsArray = function getTransactionMarketDisplayLabelsArray(item) {
  var _context4, _context5;
  if (!(item !== null && item !== void 0 && item.locations) || !_Array$isArray(item.locations)) {
    return [];
  }
  var displayMarketLabels = new _Set(item === null || item === void 0 ? void 0 : _mapInstanceProperty(_context4 = _filterInstanceProperty(_context5 = item.locations).call(_context5, function (location) {
    return !!location.displayMarketLabel;
  })).call(_context4, function (location) {
    return location.displayMarketLabel;
  }));
  return _Array$from(displayMarketLabels);
};
export var combineEnumObjects = function combineEnumObjects(enumObjects) {
  var combinedValues = {};
  _forEachInstanceProperty(enumObjects).call(enumObjects, function (enumObj) {
    if (enumObj && _valuesInstanceProperty(enumObj)) {
      _Object$assign(combinedValues, _valuesInstanceProperty(enumObj));
    }
  });
  return {
    values: combinedValues
  };
};